// T2T-05-C4 — SSE connection state banner inside EmbeddedChat.

import React from "react";
import PropTypes from "prop-types";

export default function ConnectionBanner({ status, onRefreshThread }) {
  if (status === "connected" || status === "connecting") return null;

  if (status === "disconnected") {
    return (
      <div
        role="status"
        style={{
          background: "#FEF3C7", color: "#92400E", border: "1px solid #FDE68A",
          borderRadius: "var(--t2t-radius)", padding: "6px 10px", fontSize: 11,
          display: "flex", alignItems: "center", gap: 8, marginBottom: 6,
        }}
      >
        <i className="bi bi-wifi-off" />
        <span style={{ flex: 1 }}>Connection interrupted — reconnecting…</span>
      </div>
    );
  }
  // failed
  return (
    <div
      role="alert"
      style={{
        background: "#FEE2E2", color: "#DC2626", border: "1px solid #FECACA",
        borderRadius: "var(--t2t-radius)", padding: "6px 10px", fontSize: 11,
        display: "flex", alignItems: "center", gap: 8, marginBottom: 6,
      }}
    >
      <i className="bi bi-exclamation-triangle-fill" />
      <span style={{ flex: 1 }}>Live updates failed. Click Refresh to reload.</span>
      <button type="button" className="t2t-btn t2t-btn-ghost t2t-btn-sm" onClick={onRefreshThread} style={{ color: "#DC2626" }}>
        Refresh
      </button>
    </div>
  );
}

ConnectionBanner.propTypes = {
  status:           PropTypes.string.isRequired,
  onRefreshThread:  PropTypes.func.isRequired,
};
